export interface FinalInspectionItem {
  itemId?: number;
  sortOrder?: number | null;
  itemName: string;
  standardText?: string | null;
  methodText?: string | null;
  sample1?: string | null;
  sample2?: string | null;
  sample3?: string | null;
  sample4?: string | null;
  sample5?: string | null;
  judgment?: string | null;
}

export interface FinalInspection {
  inspectionId: number;
  inventoryId: number;
  contractId?: number | null;
  itemKind?: string | null;
  itemName?: string | null;
  specText?: string | null;
  formId?: number | null;
  formTitle?: string | null;
  authorName?: string | null;
  reviewerName?: string | null;
  approverName?: string | null;
  approverUserId?: number | null;
  canRevoke?: boolean | null;
  approvalInProgress?: boolean | null;
  pendingApprovalRequestId?: number | null;
  canCancelApproval?: boolean | null;
  status: string;
  lotNo?: string | null;
  lotQty?: string | null;
  inspectorName?: string | null;
  inspectionDate?: string | null;
  categoryLabel?: string | null;
  overallJudgment?: string | null;
  remark?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  items?: FinalInspectionItem[] | null;
  attachments?: FinalInspectionAttachment[] | null;
}

export interface FinalInspectionAttachment {
  attachmentId: number;
  attachmentKind?: string | null;
  fileName: string;
  contentType?: string | null;
  fileSize?: number | null;
  createdAt?: string | null;
}

export interface FinalInspectionPayload {
  inventoryId: number;
  contractId?: number | null;
  formId?: number | null;
  formTitle?: string;
  authorName?: string;
  status?: string;
  lotNo?: string;
  lotQty?: string;
  inspectorName?: string;
  inspectionDate?: string | null;
  categoryLabel?: string;
  overallJudgment?: string;
  remark?: string;
  items?: FinalInspectionItem[];
}

export function finalInspectionStatusLabel(
  status?: string | null,
  approvalInProgress?: boolean | null
) {
  if (approvalInProgress) return '결재 요청 중';
  if (status === 'APPROVED') return '승인완료';
  if (status === 'COMPLETED') return '등록완료';
  if (status === 'DRAFT') return '작성중';
  return status || '-';
}
